module.exports = __webpack_public_path__ + "img/code-slogan.ef12f24f.png";